import { Injectable } from '@angular/core';
import { ConsumeCredencialesService } from '../generico/servicio/consume-credenciales.service';
import { MensajeService } from '../generico/servicio/mensaje.service';
import { SpinnerService } from '../spinner.service';

@Injectable({
  providedIn: 'root'
})
export class PerfilesService {


  id_perfil :number;
  constructor(
    private cred_serv : ConsumeCredencialesService,
    private msj_serv : MensajeService,
    private spiner : SpinnerService
  ) { }

  /**
   * 
   * @param data_form datos para crear el perfil.
   */
  public async gestionar_perfil(data_form){

    const promesa = this.cred_serv.post('gestionarPerfil',data_form).toPromise();

    await promesa.
        then(
          (data : any) =>{
              let tipo_msg = this.msj_serv.TIPO_OK;
              this.spiner.spin$.next(false);

              if (data.code > 0 ){
                tipo_msg = this.msj_serv.TIPO_ERROR
              }
              this.msj_serv.ver_mensaje(data.msg, '', tipo_msg);
          }
        );

  }


}
